import { Observable } from 'rxjs';
import { DashboardModel } from '../../../store/dashboard/model';
import { InteractorResponse } from '../../models/interactor-response';

export abstract class AbstractDashboardApiService {
  public abstract load(): Observable<InteractorResponse<DashboardModel>>;
  public abstract save(entity: DashboardModel): Observable<InteractorResponse<any>>;
  public abstract uploadBackgroundImage(file: File): Observable<InteractorResponse<any>>;
  public abstract deleteBackgroundImage(): Observable<InteractorResponse<any>>;
}
